import createBreakpoints from '@material-ui/core/styles/createBreakpoints'

export const breakpointsOptions = {
	values: {
		xs: 0,
		sm: 600,
		md: 900,
		lg: 1200,
		xl: 1536,
	},
	unit: 'px',
};

export const breakpoints = createBreakpoints(breakpointsOptions);
